'use client';

import { AnalyticsSkuViewed } from '@repo/segment/Analytics/AnalyticsSkuViewed';
import { SEGMENT_SKU_VIEWED_SOURCE } from '@repo/segment/Analytics/constants';
import type { FilteredReviewContentSectionOffer } from '@repo/supergraph-schemas/review/bankingPage/types';
import type { DriverGroup } from '../../utils';
import { ColumnContent } from './ColumnContent';

type ColumnProps = {
  columnIndex: number;
  groupedDrivers: DriverGroup[][];
  marketplaceEntity?: FilteredReviewContentSectionOffer;
  totalRows: number;
  isCurrentPageInstitution?: boolean;
  impressionPosition?: number;
};

export const Column = ({
  marketplaceEntity,
  columnIndex,
  groupedDrivers,
  totalRows,
  isCurrentPageInstitution = false,
  impressionPosition,
}: ColumnProps) => {
  if (!marketplaceEntity) {
    return null;
  }

  const { name, productType, product, id, institution, monetizable } = marketplaceEntity;

  return (
    <AnalyticsSkuViewed
      source={SEGMENT_SKU_VIEWED_SOURCE}
      name={name}
      productType={productType}
      level="offer"
      institutionId={institution?.id}
      institutionName={institution.name}
      productId={product.id}
      productName={product.name}
      offerId={id}
      offerName={name}
      monetizable={monetizable}
      impressionSection="banking_review_redesign_compare_card"
      impressionPosition={impressionPosition}
      additionalAttributes={{
        page_type: 'review',
      }}
    >
      <ColumnContent
        marketplaceEntity={marketplaceEntity}
        columnIndex={columnIndex}
        groupedDrivers={groupedDrivers}
        totalRows={totalRows}
        isCurrentPageInstitution={isCurrentPageInstitution}
      />
    </AnalyticsSkuViewed>
  );
};
